var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Ellipsoid, Cartographic } from '@skand/math';
class GeoJsonLoader {
    /**
     * Get shapeType
     *
     * @param shapeType
     */
    getShapeType(shapeType) {
        switch (shapeType) {
            case 'LineString':
                return 'POLYLINE';
            case 'Polygon':
                return 'POLYGON';
            case 'Point':
                return 'POINT';
        }
    }
    /**
     * Get fieldType
     *
     * @param key
     */
    getFieldType(key) {
        if (typeof key === 'string') {
            const matches = key.match(/\(([^)]+)\)/); // Match anything inside parentheses
            if (matches && matches.length > 1) {
                return matches[1].trim(); // Return the value inside parentheses, trimmed of any surrounding spaces
            }
        }
    }
    /**
     * Get fields
     *
     * @param properties
     */
    getFields(properties) {
        const fields = [];
        for (const key in properties) {
            if (key !== 'name' &&
                key !== 'fill' &&
                key !== 'stroke' &&
                key !== 'marker-color' &&
                key !== 'stroke-width' &&
                key !== 'fill-opacity') {
                const fieldName = key.replace(/\s*\(.*?\)\s*/g, ''); // Remove anything within parentheses and the surrounding spaces
                const fieldType = this.getFieldType(key);
                switch (fieldType) {
                    case 'FILE': {
                        const fieldValue = properties[key];
                        fields.push({
                            name: fieldName,
                            type: fieldType,
                            files: fieldValue,
                        });
                        break;
                    }
                    case 'URL': {
                        const fieldValue = properties[key];
                        fields.push({
                            name: fieldName,
                            type: fieldType,
                            urls: fieldValue,
                        });
                        break;
                    }
                    default: {
                        const fieldValue = properties[key];
                        fields.push({
                            name: fieldName,
                            type: fieldType,
                            value: fieldValue,
                        });
                    }
                }
            }
        }
        return fields;
    }
    /**
     * Get the list of annotation objects from json string
     *
     * @param input
     */
    read(json) {
        return __awaiter(this, void 0, void 0, function* () {
            const string = JSON.parse(json);
            const annotations = string.features.map((feature) => {
                const name = feature.properties.name;
                const color = feature.properties.fill;
                let positions = [];
                if (feature.geometry.type === 'Polygon') {
                    const coordinates = feature.geometry.coordinates[0].map((position) => {
                        return Ellipsoid.WGS_84.cartesianForCartographic(new Cartographic((position[0] * Math.PI) / 180, (position[1] * Math.PI) / 180, position[2]));
                    });
                    // Remove last position if shapetype is polygon
                    coordinates.pop();
                    positions = [...positions, ...coordinates];
                }
                if (feature.geometry.type === 'LineString') {
                    const coordinates = feature.geometry.coordinates.map((position) => {
                        return Ellipsoid.WGS_84.cartesianForCartographic(new Cartographic((position[0] * Math.PI) / 180, (position[1] * Math.PI) / 180, position[2]));
                    });
                    positions = [...positions, ...coordinates];
                }
                if (feature.geometry.type === 'Point') {
                    const position = feature.geometry.coordinates;
                    const coordinates = Ellipsoid.WGS_84.cartesianForCartographic(new Cartographic((position[0] * Math.PI) / 180, (position[1] * Math.PI) / 180, position[2]));
                    positions = [...positions, coordinates];
                }
                const annotation3d = {
                    positions,
                    shapeType: this.getShapeType(feature.geometry.type),
                };
                const fields = this.getFields(feature.properties);
                return {
                    name,
                    color,
                    annotation3d,
                    fields,
                };
            });
            return annotations;
        });
    }
}
export default GeoJsonLoader;
